module.exports = __webpack_public_path__ + "media/brand/CardkiveLogo-94df6f4e.svg";